(function () {
  const PROXY_URL = "https://digidrub.in/erp-proxy-ue.php"; 

  async function fetchAndSync(sku, variant_id, product_id) {
    try {
      const res = await fetch(PROXY_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sku, variant_id, product_id }),
      });
      const data = await res.json();
      if (data.success) {
        applyStockToPage(data.erp);
      }
    } catch (e) {
      console.warn("ERP sync error:", e);
    }
  }

  function applyStockToPage(item) {
    if (!item) return;

    const qtyEl = document.querySelector(".erp-stock-qty");
    if (qtyEl) qtyEl.textContent = item.instockQty > 0 ? `${item.instockQty} available` : "Out of stock";

    const atcBtn = document.querySelector('[name="add"], #AddToCart');
    if (atcBtn && item.allowOutOfStockSales === "deny" && item.instockQty <= 0) {
      atcBtn.disabled = true;
      atcBtn.textContent = "Out of Stock";
    }

    const etaEngEl = document.querySelector(".erp-eta-eng");
    if (etaEngEl) etaEngEl.textContent = item.etaEng && item.etaEng !== "0" ? `Ships in ${item.etaEng} days` : "";

    const etaArbEl = document.querySelector(".erp-eta-arb");
    if (etaArbEl) etaArbEl.textContent = item.etaArb && item.etaArb !== "0" ? item.etaArb : "";
  }

  function init() {
    const el = document.getElementById("erp-stock-data");
    if (!el) return;

    const sku        = el.dataset.sku;
    const variant_id = el.dataset.variantId;
    const product_id = el.dataset.productId;

    if (!sku || !variant_id || !product_id) {
      console.warn("ERP: Missing sku, variant_id or product_id");
      return;
    }

    fetchAndSync(sku, variant_id, product_id);
  }

  // Re-sync on variant switch
  document.addEventListener("variant:change", (e) => {
    const v = e.detail?.variant;
    if (!v) return;
    const el = document.getElementById("erp-stock-data");
    const product_id = el?.dataset.productId;
    fetchAndSync(v.sku, v.id, product_id);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  setTimeout(function() {
    if (!sessionStorage.getItem('erp_reloaded')) {
        sessionStorage.setItem('erp_reloaded', 'true');
        location.reload();
    }
}, 3000);
  setTimeout(function() {
    if (!sessionStorage.getItem('erp_reloaded')) {
        sessionStorage.setItem('erp_reloaded', 'true');
        location.reload();
    }
}, 3000);

})();